import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { DsFormFieldModule, DsIconModule } from '@bmw-ds/components';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass, NgIf } from '@angular/common';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'density-input-text',
    imports: [DsFormFieldModule, DsIconModule, TranslateModule, NgIf, FormsModule, NgClass],
    templateUrl: './density-input-text.component.html',
    styleUrl: './density-input-text.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DensityInputTextComponent),
            multi: true
        }
    ]
})
export class DensityInputTextComponent extends ValueAccessor<string> {
    private static nextId = 0;

    @Input()
    inputId: string = `density-input-${DensityInputTextComponent.nextId++}`;

    @Input()
    disabled: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    maxLength: number | null = null;

    @Input()
    label: string = '';

    @Input()
    placeholder: string = '';

    @Input()
    invalid: boolean = false;

    @Input()
    styleClass: string = '';

    @Input()
    icon: string = '';

    @Input()
    displayWith?: (value: any) => string;

    @Output()
    valueChanged = new EventEmitter<string>();

    constructor(injector: Injector) {
        super(injector);
    }

    set displayValue(val: string) {
        this.value = val;
        this.valueChanged.emit(val);
    }

    get displayValue(): string {
        if (this.value === null || this.value === undefined) {
            return '';
        }

        if (!this.displayWith) {
            return this.value;
        }

        return this.displayWith(this.value);
    }
}
